export default __webpack_public_path__ + "static/media/egg.0ee34e39.jpg";